import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import DashboardTopSearch from "../../../components/DashboardTopSearch/DashboardTopSearch";
import StudentsAssignment from "../../../components/assignmentTable/assignmentTable";
import { useDispatch, useSelector } from "react-redux";
import { studentAssignmentSubmitAPI } from "../../../redux/features/courseSlice";
import { useSearchParams } from "react-router-dom";
import { toast } from "react-hot-toast";
import AdminNotification from "../../../components/Notification/AdminNotification";
import InstructorNotification from "../../../components/Notification/InstructorNotification";

const AssignmentTable = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [searchParams] = useSearchParams();
  const auth = useSelector((state) => state.auth);

  const [studentAssignmentList, setStudentAssignmentList] = useState([]);

  const fetchAssignment = async () => {
    const res = await dispatch(
      studentAssignmentSubmitAPI({
        token: auth.token,
        id: searchParams.get("id"),
        course_id: searchParams.get("course_id"),
      })
    ).unwrap();

    if (res.success) {
      // toast.success(res?.message, {
      //   position: "top-center",
      // });
      setStudentAssignmentList(res?.data);
    }
  };

  useEffect(() => {
    fetchAssignment();
  }, []);

  const goBack = () => {
    navigate(-1);
  };

  return (
    <>
      <div className="topbar mb-20 mb-lg-36">
        <div className="d-flex align-items-center justify-content-between">
          <h3
            className="ah-heading-04 fw-bold black-800 me-29 mb-0 d-flex align-items-center gap-3 cursor-pointer"
            onClick={goBack}
          >
            <span className="icon-arrow-left"></span>Assignment
          </h3>
          <div className="search-wrapper d-none d-lg-flex align-items-center gap-3">
            <DashboardTopSearch />
            {auth.role === "Admin" ? (
              <AdminNotification />
            ) : auth.role === "Instructor" ? (
              <InstructorNotification />
            ) : (
              ""
            )}
          </div>
        </div>
      </div>

      <div className="d-flex justify-content-between align-items-center flex-wrap mb-20">
        {/* <h4 className="ah-heading-05 h4 fw-bold text-black">Assignment</h4> */}
      </div>

      <StudentsAssignment assignmentList={studentAssignmentList} />
    </>
  );
};

export default AssignmentTable;
